import { Locale } from '@/enums/lang';
export const localeSet: string[] = [Locale.EN, Locale.CN, Locale.KO];
export const defaultLang = Locale.CN;
